import CircularProgressBar from "common-ui-components/components/circular-progress-bar/CircularProgressBar";
import React from "react";
import StatTiles from "common-ui-components/components/stat-tiles/StatTiles";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import styles from "./PatchCompliance.module.css";

const formatCount = (value, loading) =>
  loading ? "--" : value == null ? "--" : Number(value).toLocaleString();

const PatchCompliance = ({ overview, loading = false }) => {
  const total = Number(overview?.totalPatches) || 0;
  const installed = Number(overview?.totalInstalledPatches) || 0;
  const percent = total ? Number(((installed / total) * 100).toFixed(1)) : 0;
  const patchStats = [
    { label: "Installed", value: formatCount(overview?.totalInstalledPatches, loading), color: "#059669" },
    { label: "Missing", value: formatCount(overview?.totalMissingPatches, loading), color: "#dc2626" },
    // TODO: Add the downloads-pending count when the overview API exposes it.
    { label: "Downloads pending", value: "--", color: "#2563eb" },
    { label: "Failed deployments", value: formatCount(overview?.failedDeployments, loading), color: "#dc2626" },
  ];
  return (
    <InfoBox
      header="Patch Compliance Overview"
      subtitle="Installation status across managed devices"
      badge="Current status"
      badgeProps={{
        style: { background: "#eef2ff", color: "#2e5bdc" },
      }}
      childrenProps={{
        className: styles.complianceContent,
      }}
      style={{ minWidth: 0 }}
    >
      <CircularProgressBar
        percent={loading ? 0 : percent}
        percentStyles={{ fontSize: "1.6rem", top: "0.8rem", color: "#059669" }}
        size="12rem"
        thickness={0.2}
        color="#059669"
        titleStyles={{ fontSize: "1.2rem" }}
        actAsGauge
      />
      <StatTiles items={patchStats} columns={2} loading={loading} />
    </InfoBox>
  );
};

export default PatchCompliance;
